import React from 'react'

export const Start = () => {
  return (
    <>
      <h1 className="title">Ground Operations Admin</h1>
    </>
  )
}
